import API, { apiErrorMessage } from "../global/api";

// Add HS Code
export const addHsCodeRequest = () => {
  return {
    type: "ADD_HS_CODE_REQUEST",
  };
};
export const addHsCodeSuccess = (data) => {
  return {
    type: "ADD_HS_CODE_SUCCESS",
    payload: data,
  };
};
export const addHsCodeError = (msg) => {
  return {
    type: "ADD_HS_CODE_ERROR",
    payload: msg,
  };
};
export const addHsCode = (
  data,
  setFormData,
  handleVisible,
  handleDangerVisible,
) => {
  return (dispatch) => {
    dispatch(addHsCodeRequest());
    API.post(`/HSCode/add-code`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(addHsCodeSuccess(data1));
        handleVisible(res.data.message);
        setFormData({
          pctCode: "",
          description: "",
        });
      })
      .catch((error) => {
        dispatch(addHsCodeError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Getting HS Code List
export const getHsCodeRequest = () => {
  return {
    type: "HS_CODE_LIST_REQUEST",
  };
};
export const getHsCodeSuccess = (data) => {
  return {
    type: "HS_CODE_LIST_SUCCESS",
    payload: data,
  };
};
export const getHsCodeError = (msg) => {
  return {
    type: "HS_CODE_LIST_ERROR",
    payload: msg,
  };
};
export const getHsCode = (page, limit, globalFilter) => {
  return (dispatch) => {
    dispatch(getHsCodeRequest());
    API.get(`/HSCode/get-codes?page=${page}&limit=${limit}&search=${globalFilter}`)
      .then((res) => {
        let hsCodeList = res.data;
        dispatch(getHsCodeSuccess(hsCodeList));
      })
      .catch((error) => {
        dispatch(getHsCodeError(apiErrorMessage(error)));
      });
  };
};

// Updating Hs Code
export const updateHsCodeRequest = () => {
  return {
    type: "UPDATE_HS_CODE_LIST_REQUEST",
  };
};
export const updateHsCodeSuccess = (data) => {
  return {
    type: "UPDATE_HS_CODE_LIST_SUCCESS",
    payload: data,
  };
};
export const updateHsCodeError = (msg) => {
  return {
    type: "UPDATE_HS_CODE_LIST_ERROR",
    payload: msg,
  };
};
export const updateHsCode = (id, data, handleVisible, handleDangerVisible, page, limit) => {
  return (dispatch) => {
    dispatch(updateHsCodeRequest());
    API.put(`/HSCode/update-code/${id}`, data)
      .then((res) => {
        let updateHsCodeList = res.data;
        dispatch(updateHsCodeSuccess(updateHsCodeList));
        handleVisible(res.data.message);
        getHsCode(page, limit);
      })
      .catch((error) => {
        dispatch(updateHsCodeError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Deleting Hs Code
export const deleteHsCodeRequest = () => {
  return {
    type: "DELETE_HS_CODE_LIST_REQUEST",
  };
};
export const deleteHsCodeSuccess = (data) => {
  return {
    type: "DELETE_HS_CODE_LIST_SUCCESS",
    payload: data,
  };
};
export const deleteHsCodeError = (msg) => {
  return {
    type: "DELETE_HS_CODE_LIST_ERROR",
    payload: msg,
  };
};
export const deleteHsCode = (id, handleVisible, handleDangerVisible, page, limit) => {
  return (dispatch) => {
    dispatch(deleteHsCodeRequest());
    API.delete(`/HSCode/delete-code/${id}`)
      .then((res) => {
        let deleteHsCodeList = res.data;
        dispatch(deleteHsCodeSuccess(deleteHsCodeList));
        handleVisible(res.data.message);
        getHsCode(page, limit);
      })
      .catch((error) => {
        dispatch(deleteHsCodeError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};
